import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from '@tech-services/common.service';
import {
  CancelResponseModel,
  DeviceDetectorService,
  DocmanagerService,
  NotificationResponseInterface,
  NotificationsResponseModel,
} from '@techrules/portallib';
import { Subject, throwError } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import {
  faAt,
  faEnvelopeOpenText,
  faLightbulbOn,
  faUser,
  faSlidersH as farSlidersH,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faChevronDown,
  faChevronRight,
  faEnvelopeOpen,
  faSlidersH as fasSlidersH,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faFileAlt,
  faFileChartPie,
  faFileDownload,
} from '@fortawesome/pro-light-svg-icons';
import { SessionService } from '@tech-services/session.service';
import { AppConfig } from '@tech-utils/app-config.service';
import { Utils } from '@tech-utils/utils';

@Component({
  selector: 'tech-documentation',
  templateUrl: './documentation.component.html',
  styleUrls: ['./documentation.component.scss'],
})
export class DocumentationComponent implements OnInit {
  faFileDownload = faFileDownload;
  faFileAlt = faFileAlt;
  faFileChatPie = faFileChartPie;
  faAt = faAt;
  faUser = faUser;
  faLightBulbOn = faLightbulbOn;
  faEnvelopeOpen = faEnvelopeOpen;
  faEnvelopeOpenText = faEnvelopeOpenText;
  fasSlidersH = fasSlidersH;
  farSlidersH = farSlidersH;
  faChevronDown = faChevronDown;
  faChevronRight = faChevronRight;
  panelOpenState = false;

  public portfolioCode: string;
  private unsubscribe$ = new Subject<void>();
  public isMovil: boolean;
  public arrtypenotification = [];
  public documentationList: any[] = [];
  public documentationmassiveList: any[] = [];
  public documentationListFull: any[] = [];
  public notifications: NotificationsResponseModel;
  public showFilterData = false;
  public markall = false;
  public numUnread: number = 0;
  public selectedElement;
  public limit: number = 300;
  public notificationData: NotificationResponseInterface;
  private stopLoad = false;
  private subject: Subject<string> = new Subject();
  public borderDropDownList: string = AppConfig.settings.borderDropDownList;
  public showFilter = false;

  constructor(
    private deviceService: DeviceDetectorService,
    private docmanagerService: DocmanagerService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private commonService: CommonService,
    private sesionService: SessionService
  ) {}

  ngOnInit() {
    this.commonService.loading$.next(true);

    this.translate.get('k001092').subscribe((text: string) => {
      this.commonService.setTitle(text + ' | ' + AppConfig.settings.tabTitle);
    });

    this.subject.pipe(debounceTime(500)).subscribe((value) => {
      this.getDocuments();
    });

    this.isMovil = this.deviceService.isMobile();
    this.translate.get('notifications').subscribe((text: string) => {
      this.getDocuments();
    });
  }

  fillTypeNotifications() {
    this.arrtypenotification = [];
    this.arrtypenotification.push({
      label: this.translate.instant('k000058'),
      value: 'ALL',
    });

    this.documentationListFull.forEach((i) => {
      if (this.arrtypenotification.findIndex((e) => e.value === i.Type) < 0) {
        this.arrtypenotification.push({
          label: this.getTypeNotificationNameByType(i.Type),
          value: i.Type,
        });
      }
    });

    if (this.arrtypenotification.length > 2) {
      this.showFilter = true;
    }
    this.selectedElement = this.arrtypenotification[0];
  }

  getTypeNotificationName(CategoriaId) {
    let tName = '';
    switch (CategoriaId) {
      case '1': //Legal Document
        tName = this.translate.instant('k004371'); //'Provided';
        break;
      case '2': //General Document
        tName = this.translate.instant('k004372'); //'Generally signed';
        break;
      case '3': //Order and Proposal
        tName = this.translate.instant('k001927');
        break;
      case '4': //Shedule Report
        tName = this.translate.instant('k000854');
        break;
      case '5': //Masive Report
        tName = this.translate.instant('k000854'); //this.translate.instant('k000854'); //k001927
        break;
      case '6': //Other Documents
        tName = this.translate.instant('k001929');
        break;
      case '7': //NOSE
        tName = this.translate.instant('k004371'); //'Provided';
        break;
      case '8': //Account Statements
        tName = this.translate.instant('k004375'); //'Account statements';
        break;
      default:
        tName = CategoriaId;
    }
    return tName;
  }

  getTypeNotificationNameByType(type) {
    let tName = '';
    switch (type) {
      case 'LEGALDOCUMENTS':
        tName = this.translate.instant('k004371');
        break;
      case 'REPORT':
        tName = this.translate.instant('k001913');
        break;
      case 'SIGNEDDOCUMENTS':
        tName = this.translate.instant('k000852');
        break;
      case 'OTHERSDOCUMENTS':
        tName = this.translate.instant('k000840');
        break;
      case 'ACCOUNTSTATEMENTS':
        tName = this.translate.instant('k004375');
        break;
      case 'ORDERS&PROPOSAL':
        tName = this.translate.instant('k001927');
        break;
      default:
        tName = type;
    }
    return tName;
  }
  changeDocument(e) {
    if (e === 'ALL') {
      this.documentationList = this.documentationListFull;
    } else {
      this.documentationList = this.documentationListFull.filter(
        (t) => t.Type === e
      );
    }
  }

  async getDocuments() {
    if (!this.stopLoad) {
      const promises = [];

      //Handler SheduleReports
      let prom1 = this.docmanagerService
        .getSheduleReports()
        .toPromise()
        .then(
          (data) => {
            data.forEach((e) => {
              if (e.Scheduledreportsgenerated) {
                e.Scheduledreportsgenerated.forEach((d) => {
                  let doc: any = {};
                  doc.Date = d.Date.replace(/ /g, 'T');
                  const date = new Date(doc.Date);
                  doc.Name = this.translate.instant('k001783') + ': ' + e.Name;
                  doc.Type = 'REPORT';
                  doc.SubType = 'ScheduledReport';
                  doc.Id = d.Scheduledreportid;
                  doc.ContractCodeEncrypted = '';
                  doc.ContractCode = '';
                  doc.DocumentFilename = e.Name + '.pdf';
                  doc.CategoryId = '5';
                  doc.IsManual = false;
                  doc.FileType = 'pdf';
                  doc.Icon = this.getDocumentationIcon(doc.Type);
                  doc.ChannelClass = 'vertical-timeline-icon modshedulereport';
                  doc.ChannelClassMobile = 'redondeo modshedulereport';

                  this.documentationListFull.push(doc);
                });
              }
            });
          },
          (err) => {
            this.commonService.errorManager(err.error.Code, err);
            this.commonService.loading$.next(false);
          }
        );

      promises.push(prom1);

      //Handler de Masssive
      let prom2 = this.docmanagerService
        .getMassiveReport()
        .toPromise()
        .then(
          (data) => {
            data.Result.forEach((e) => {
              let doc: any = {};
              doc.Date = e.ReportDate.replace(/ /g, 'T');
              const date = new Date(doc.Date);
              const previousMonth = new Date(date);
              previousMonth.setMonth(previousMonth.getMonth() - 1);
              doc.Name =
                this.translate.instant('k001783') + ': ' + e.ElementName;
              /*
                previousMonth.toLocaleString(this.sesionService.language, {
                  month: 'long',
                }) +
                ' ' +
                date.toLocaleString(this.sesionService.language, {
                  year: 'numeric',
                });
                */
              doc.Type = 'REPORT';
              doc.SubType = 'MassiveReport';
              doc.Id = e.ReportId;
              doc.ContractCodeEncrypted = '';
              doc.ContractCode = '';
              doc.DocumentFilename = e.ReportType + '.pdf';
              doc.CategoryId = '5';
              doc.IsManual = false;
              doc.FileType = 'pdf';
              doc.Icon = this.getDocumentationIcon(doc.Type);
              doc.ChannelClass = 'vertical-timeline-icon modmassivereport';
              doc.ChannelClassMobile = 'redondeo modmassivereport';

              this.documentationListFull.push(doc);
            });
          },
          (err) => {
            this.commonService.errorManager(err.error.Code, err);
            this.commonService.loading$.next(false);            
          }
        );

      promises.push(prom2);

      //Handler SignedDocuments
      let prom3 = this.docmanagerService
        .getSignedDocuments()
        .toPromise()
        .then((data) => {
          data.forEach((e) => {
            let doc: any = {};
            doc.Date = e.CreateDate.replace(/ /g, 'T');
            doc.Name = e.Name;
            doc.Type = 'SIGNEDDOCUMENTS';
            doc.SubType = 'SignedDocuments';
            doc.Id = e.DocumentID;
            doc.ContractCode = e.ContractCode;
            doc.ContractCodeEncrypted = e.ContractCodeEncrypted;
            doc.DocumentFilename = e.DocumentFilename;
            doc.CategoryId = '2';
            doc.IsManual = false;
            doc.FileType = e.DocumentType;
            doc.Icon = this.getDocumentationIcon(doc.Type);
            doc.ChannelClass = this.getChannelClass(doc.CategoryId);
            doc.ChannelClassMobile = this.getChannelClassMovil(doc.CategoryId);

            this.documentationListFull.push(doc);
          });
        });

      promises.push(prom3);

      let prom4 = this.docmanagerService
        .getDocuments()
        .toPromise()
        .then(
          (data: any) => {
            let arr = [];
            if (Array.isArray(data)) {
              arr = data;
            } else if (Array.isArray(data.Result)) {
              arr = data.Result;
            }

            arr.forEach((e) => {
              let doc: any = {};
              doc.Date = e.LastDate.replace(/ /g, 'T');
              doc.Name = e.Name;
              doc.CategoryId = e.CategoryId;
              doc.IsManual = true;

              switch (e.CategoryId) {
                case '1': //Legal Document
                  doc.Type = 'LEGALDOCUMENTS';
                  doc.SubType = 'ManualDocuments';
                  break;
                case '2': //General Document
                  doc.Type = 'SIGNEDDOCUMENTS';
                  doc.SubType = 'ManualDocuments';
                  break;
                case '3': //Order and Proposal
                  doc.Type = 'ORDERS&PROPOSAL';
                  doc.SubType = 'ManualDocuments';
                  break;
                case '4': //Proposals
                  doc.Type = 'ORDERS&PROPOSAL';
                  doc.SubType = 'ManualDocuments';
                  break;
                case '5': //Masive Report ya no sino Propuestas//SIEMPRE % CUANDO SON MANUALES
                  doc.Type = 'REPORT'; //REPORT
                  doc.SubType = 'ManualDocuments';
                  break;
                case '6': //Other Documents
                  doc.Type = 'OTHERSDOCUMENTS';
                  doc.SubType = 'ManualDocuments';
                  break;
                case '7':
                  doc.Type = 'LEGALDOCUMENTS';
                  doc.SubType = 'ManualDocuments';
                  break;
                case '8': //Account Statements
                  doc.Type = 'ACCOUNTSTATEMENTS';
                  doc.SubType = 'ManualDocuments';
                  break;
                default:
                  doc.Type = 'OTHERSDOCUMENTS';
                  doc.SubType = 'ManualDocuments';
              }

              doc.Id = e.Id;
              doc.ContractCodeEncrypted = '';
              doc.ContractCode = e.ContractCode;
              doc.DocumentFilename = e.FileName;
              doc.FileType = e.FileType;
              doc.Icon = this.getDocumentationIcon(doc.Type);
              doc.ChannelClass = this.getChannelClass(doc.CategoryId);
              doc.ChannelClassMobile = this.getChannelClassMovil(
                doc.CategoryId
              );
              this.documentationListFull.push(doc);
            });
          },
          (err) => {
            this.commonService.errorManager(err.error.Code, err);
            this.commonService.loading$.next(false);            
          }
        );

      promises.push(prom4);

      //Handler SignedDocuments
      let prom5 = this.docmanagerService
        .getOthersDocuments()
        .toPromise()
        .then((data) => {
          data.forEach((e) => {
            let doc: any = {};
            doc.Date = e.CreateDate.replace(/ /g, 'T');
            doc.Name = e.Name;
            doc.Type = 'OTHERSDOCUMENTS';
            doc.SubType = 'OthersDocuments';
            doc.Id = e.DocumentID;
            doc.ContractCodeEncrypted = e.ContractCodeEncrypted;
            doc.ContractCode = e.ContractCode;
            doc.DocumentFilename = e.DocumentFilename;
            doc.CategoryId = '6';
            doc.IsManual = false;
            doc.FileType = e.DocumentType;
            doc.Icon = this.getDocumentationIcon(doc.Type);
            doc.ChannelClass = this.getChannelClass(doc.CategoryId);
            doc.ChannelClassMobile = this.getChannelClassMovil(doc.CategoryId);

            this.documentationListFull.push(doc);
          });
        });

      promises.push(prom5);

      //Handler SignedDocuments

      let prom6 = this.docmanagerService
        .getAccountStatementsDocument()
        .toPromise()
        .then((data) => {
          data.forEach((e) => {
            let doc: any = {};
            doc.Date = e.CreateDate.replace(/ /g, 'T');
            const date = this.getDateInMonthTextYear(
              new Date(e.Date),
              this.translate.currentLang
            );
            doc.Name = Utils.formatString(this.translate.instant('k004370'), [
              date + ': ' + e.PortfolioDescription,
            ]);
            /*
            let doc: any = {};
            doc.Date = e.CreateDate.replace(/ /g, 'T');
            doc.Name = e.Name;*/

            doc.Type = 'ACCOUNTSTATEMENTS';
            doc.SubType = 'AccountStatements';
            doc.Id = e.DocumentID;
            doc.ContractCodeEncrypted = e.ContractCodeEncrypted;
            doc.DocumentFilename = e.DocumentFilename;
            doc.ContractCode = e.ContractCode;
            doc.CategoryId = '8';
            doc.IsManual = false;
            doc.FileType = e.DocumentType;
            doc.Icon = this.getDocumentationIcon(doc.Type);
            doc.ChannelClass = this.getChannelClass(doc.CategoryId);
            doc.ChannelClassMobile = this.getChannelClassMovil(doc.CategoryId);

            this.documentationListFull.push(doc);
          });
        });

      promises.push(prom6);

      await Promise.all(promises);

      this.documentationList = this.documentationListFull;

      this.documentationList.sort(
        (a, b) => new Date(b.Date).getTime() - new Date(a.Date).getTime()
      );

      this.documentationList.forEach((n) => {
        n.Description = n.Name;
        n.DateString = new Date(n.Date).toLocaleString(
          this.sesionService.language,
          {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric',
          }
        );

        n.groupedDate = new Date(n.Date).toLocaleString(
          this.sesionService.language,
          {
            month: 'long',
            year: 'numeric',
          }
        );
      });
      this.fillTypeNotifications();
      this.commonService.loading$.next(false);
    }
  }

  public getDateInMonthTextYear(fecha: Date, language: string): string {
    const options: Intl.DateTimeFormatOptions = {
      month: 'long',
      year: 'numeric',
    };
    return fecha.toLocaleDateString(language, options);
  }

  public getDocumentationIcon(type) {
    let icon = [];
    switch (type) {
      case 'SIGNEDDOCUMENTS': //FIRMADOS
      case 'ORDERS&PROPOSAL':
        icon = ['fal', 'file-alt'];
        break;
      case 'REPORT':
      case 'OTHERSDOCUMENTS':
        icon = ['fal', 'file-chart-pie'];
        break;
      case 'MANUALDOCUMENTS':
        icon = ['fal', 'id-badge'];
        break;
      case 'ACCOUNTSTATEMENTS':
        icon = ['fal', 'file-contract'];
        break;
      case 'LEGALDOCUMENTS':
        icon = ['fal', 'id-badge'];
        break;
    }
    return icon;
  }

  public getChannelClass(categoriaId) {
    let icon = '';
    switch (categoriaId) {
      case '1': //Legal Document
        icon = 'vertical-timeline-icon modlegaldocument';
        break;
      case '2': //General Document
        icon = 'vertical-timeline-icon modgeneraldocument';
        break;
      case '3': //Order and Proposal
        icon = 'vertical-timeline-icon modorderandproposals';
        break;
      case '4': //Proposals
        icon = 'vertical-timeline-icon modorderandproposals';
        break;
      case '5': //Masive Report
        icon = 'vertical-timeline-icon modmanualreport'; //modshedulereport, modmassivereport, modmanualreport
        break;
      case '6': //Other Documents
        icon = 'vertical-timeline-icon modothersdocuments';
        break;
      case '7': //Aportados
        icon = 'vertical-timeline-icon modlegaldocument';
        break;
      case '8': //Account Statements
        icon = 'vertical-timeline-icon modaccountstatements';
        break;
    }
    return icon;
  }

  public getChannelClassMovil(categoriaId) {
    let icon = '';
    switch (categoriaId) {
      case '1': //Legal Document
        icon = 'redondeo modlegaldocument';
        break;
      case '2': //General Document
        icon = 'redondeo modgeneraldocument';
        break;
      case '3': //Order and Proposal
        icon = 'redondeo modorderandproposals';
        break;
      case '4': //Shedule Document
        icon = 'redondeo modorderandproposals';
        break;
      case '5': //Masive Report
        icon = 'redondeo modmanualreport';
        break;
      case '6': //Other Documents
        icon = 'redondeo modothersdocuments';
        break;
      case '7': //Aportados
        icon = 'redondeo modlegaldocument';
        break;
      case '8': //Account Statements
        icon = 'redondeo modaccountstatements';
        break;
    }
    return icon;
  }

  public documentdownloadid(item) {
    //this.commonService.loading$.next(true);
    this.commonService.portfolioCode$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((val) => {
        if (Object.entries(val).length !== 0 && val != 'undefined') {
          this.portfolioCode = val;
        }
      });

    switch (item.SubType) {
      case 'ScheduledReport':
        this.getDocumentSheduleReportId(item);
        break;
      case 'MassiveReport':
        this.getDocumentMassiveReportId(item);
        break;
      case 'SignedDocuments':
        if (item.ContractCode) this.getDocument2(item);
        else this.getDocument1(item);
        break;
      case 'ManualDocuments':
        this.getManualDocument(item);
        break;
      case 'OthersDocuments':
        if (item.ContractCode) this.getDocument2(item);
        else this.getDocument1(item);
        break;
      case 'AccountStatements':
        this.getNewDocument(item);
        break;
    }
    return true;
  }

  public getDocumentSheduleReportId(item) {
    this.docmanagerService.getDocumentSheduleReport(item.Id).subscribe(
      (data) => {
        let mediaType = this.getMediaType(item.FileType);

        this.downLoadBlobFile(data.body, mediaType, item.DocumentFilename);
      },
      (err) => {
        this.commonService.errorManager(
          'apirest_getDocumentSheduleReport',
          err
        );
        this.commonService.loading$.next(false);
        return throwError(err);
      }
    );
  }

  public getDocumentMassiveReportId(item) {
    this.docmanagerService.getDocumentMassiveReport(item.Id).subscribe(
      (data) => {
        let mediaType = this.getMediaType(item.FileType);

        this.downLoadBlobFile(data.body, mediaType, item.DocumentFilename);
      },
      (err) => {
        this.commonService.errorManager(
          'apirest_getDocumentMassiveReport',
          err
        );
        this.commonService.loading$.next(false);
        return throwError(err);
      }
    );
  }

  public getDocument1(item) {
    this.docmanagerService.getDocument1(item.Id).subscribe(
      (data) => {
        let mediaType = this.getMediaType(item.FileType);

        this.downLoadBlobFile(data.body, mediaType, item.DocumentFilename);
      },
      (err) => {
        this.commonService.errorManager('apirest_getDocument1', err);
        this.commonService.loading$.next(false);
        return throwError(err);
      }
    );
  }
  public getManualDocument(item) {
    this.docmanagerService.getDocumentFile(item.Id).subscribe(
      (data) => {
        let mediaType = this.getMediaType(item.FileType);

        this.downLoadBlobFile(data.body, mediaType, item.DocumentFilename);
      },
      (err) => {
        this.commonService.errorManager('apirest_getDocument1', err);
        this.commonService.loading$.next(false);
        return throwError(err);
      }
    );
  }

  public getNewDocument(item) {
    this.docmanagerService.getDocumentFile(item.Id).subscribe(
      (data) => {
        let mediaType = this.getMediaType(item.FileType);

        this.downLoadBlobFile(data.body, mediaType, item.DocumentFilename);
      },
      (err) => {
        this.commonService.errorManager('apirest_getDocument1', err);
        this.commonService.loading$.next(false);
        return throwError(err);
      }
    );
  }

  private downLoadBlobFile(data: any, type: string, name: string) {
    let blob = new Blob([data], { type: type });
    //let file = new File([data], name, { type: type });
    let url = window.URL.createObjectURL(blob);

    let a = document.createElement('a');
    document.body.appendChild(a);
    a.href = url;
    a.download = name;
    a.click();
    setTimeout(function () {
      window.URL.revokeObjectURL(url);
    }, 1000); //enough time to download report from mobile apps
  }

  private getMediaType(fileType) {
    let mediaType;
    switch (fileType) {
      case 'jpg':
        mediaType = 'image/jpeg';
        break;
      case 'png':
        mediaType = 'image/png';
        break;
      case 'gif':
        mediaType = 'image/gif';
        break;
      case 'tif':
        mediaType = 'image/tif';
        break;
      case 'txt':
        mediaType = 'text/plain';
        break;
      case 'pdf':
        mediaType = 'application/pdf';
        break;
      case 'doc':
        mediaType = 'application/msword';
        break;
      case 'docx':
        mediaType =
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        break;
      default:
        mediaType = 'image/jpeg';
        break;
    }

    return mediaType;
  }

  public getDocument2(item) {
    let portfoliocode = item.ContractCode; //item.ContractCodeEncrypted;
    let documentId = item.Id;
    let filename = item.DocumentFilename;
    this.docmanagerService.getDocument2(portfoliocode, documentId).subscribe(
      (data) => {
        //this.commonService.loading$.next(false);
        //this.downLoadFile(data.body, 'application/octet-stream', filename);
        let mediaType = this.getMediaType(item.FileType);

        this.downLoadBlobFile(data.body, mediaType, item.DocumentFilename);
      },
      (err) => {
        this.commonService.errorManager('apirest_getDocument2', err);
        this.commonService.loading$.next(false);
        return throwError(err);
      }
    );
  }

  downLoadFile(data: any, type: string, name: string) {
    let blob = new Blob([data], { type: type });
    let url = window.URL.createObjectURL(blob);
    let a = document.createElement('a');
    document.body.appendChild(a);
    a.href = url;
    a.download = name;
    a.click();
    setTimeout(function () {
      window.URL.revokeObjectURL(url);
    }, 1000); //enough time to download report from mobile apps
  }

  public filterdata() {
    this.showFilterData = !this.showFilterData;
  }

  @HostListener('window:resize') onresize() {
    this.isMovil = this.deviceService.isMobile();
  }

  onScroll = (e) => {
    if (
      e.target.offsetHeight + e.target.scrollTop >=
      e.target.scrollHeight - 1
    ) {
      this.subject.next('');
      return;
    }
  };

  selectChange($event) {}
}
